import settings from '@festi/common/constants/settings'
import {useAuth} from '@festi/common/contexts'

const onlyStaging = settings.algoliaEnv === 'stage'

export interface NavItem {
  label: string
  pagePath: string
}

export default function useMinarNavigation() {
  const {betaTester, selectedBusiness} = useAuth()

  const showSnjallgreidslur = onlyStaging && betaTester && !selectedBusiness

  const navItems: NavItem[] = [
    {
      label: 'Stillingar',
      pagePath: '/minar',
    },
    {
      label: !selectedBusiness ? '' : 'Starfsmenn',
      pagePath: '/minar/starfsmenn',
    },
    {
      label: showSnjallgreidslur ? 'Snjallgreiðslur' : '',
      pagePath: '/minar/snjallgreidslur',
    },
    {
      label: 'Nótur',
      pagePath: '/minar/notur',
    },
    {
      label: 'Fyrirtæki',
      pagePath: '/minar/fyrirtaeki',
    },
  ]

  return navItems.filter((item) => item.label !== '')
}
